import React, { useEffect, useState } from "react";
import { authApiService } from "../../api/api";
import FilterBlock from "../../components/FilterBlock/FilterBlock";
import { roleOptions } from "../../components/modals/filters/UserFilterModal/UserFilterModal";
import { SelectOption } from "../../components/modals/forms/inputs/SelectInput/SelectInput";
import Pagination from "../../components/pagination/Pagination/Pagination";
import HistoryTable from "../../components/Tables/HistoryTable";
import TableTitle from "../../components/TableTitle/TableTitle";
import { IHistory } from "../../types/history.type";
import { usersPerPage } from "../../utils/constants/page";
import styles from "./styles.module.scss";

const HistoryPage: React.FC = () => {
  const [history, seyHistory] = useState<IHistory[]>([]);
  const [filteredHistory, setFilteredHistory] = useState<IHistory[]>([]);
  const [editSelectedHistory, setEditSelectedHistory] =
    useState<IHistory | null>(null);
  const [visibleHistory, setVisibleHistory] = useState<IHistory[]>([]);
  const [activePage, setActivePage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [searchValue, setSearchValue] = useState<string>("");
  const [isInfoModal, setInfoModal] = useState<boolean>(false);
  const [isFilterModal, setIsFilterModal] = useState<boolean>(false);
  const [role, setRole] = useState<SelectOption>(roleOptions[0]);

  const getHistory = async () => {
    try {
      const response = await authApiService.getHistory();
      if (response) {
        return response;
      }
    } catch (err) {
      console.error(err);
    }
  };

  const changeVisibiltyUser = (history: IHistory[]) => {
    const indexOfLastUser = activePage * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    if (history) {
      const changedhistory = history.slice(indexOfFirstUser, indexOfLastUser);
      setVisibleHistory(changedhistory);
    }
  };

  const getOptionsFilter = () => {
    let filteredHistory = [...history];

    // if (role.value !== EmployeeType.NONE) {
    //   filteredHistory = filteredHistory.filter(
    //     (user) => user.role === role.value
    //   );
    // }

    return filteredHistory;
  };

  const onFilterChange = () => {
    const data = getOptionsFilter();
    // const filteredHistory = filterEmployees(data, searchValue);
    setFilteredHistory(data);
  };

  const getFiltredhistory = (history: IHistory[]) => {
    const data = getOptionsFilter();
    // const filteredHistory = filterEmployees(data, searchValue);
    setFilteredHistory(data);
  };

  const onClickApplyModal = async () => {
    const resp = await getHistory();
    if (resp) {
      seyHistory(resp);
      getFiltredhistory(resp);
    }
  };

  useEffect(() => {
    setTotalPages(Math.ceil(filteredHistory.length / usersPerPage));
  }, [filteredHistory]);

  useEffect(() => {
    getFiltredhistory(history);
    // setActivePage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue, history]);

  useEffect(() => {
    (async () => {
      const data = await getHistory();
      if (data) {
        await seyHistory(data);
      }
    })();
  }, []);

  useEffect(() => {
    changeVisibiltyUser(filteredHistory);
    // setTotalPages(Math.ceil(history.length / usersPerPage));
    if (activePage > totalPages) {
      if (activePage === 1) {
        setActivePage(1);
      } else {
        setActivePage(totalPages);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePage, history, totalPages, filteredHistory]);

  return (
    <main className={styles.container}>
      <div className={styles.header}>
        <TableTitle title="All" count={history?.length || 0} />
        <div>
          <FilterBlock
            searchValue={searchValue}
            onPressModal={() => setIsFilterModal(true)}
            onSearchChange={(value) => setSearchValue(value)}
            addButtonTitle="Додатки працівника"
          />
        </div>
      </div>

      <HistoryTable
        history={visibleHistory}
        callBackInfo={setInfoModal}
        callBackEdit={setEditSelectedHistory}
      />
      <Pagination
        key={totalPages}
        count={totalPages}
        activePage={activePage}
        onClick={(page) => setActivePage(page)}
        onClickNext={() => setActivePage((prevState) => (prevState += 1))}
        onClickPrev={() => setActivePage((prevState) => (prevState -= 1))}
      />
      {/* {editSelectedHistory && (
        <EditEmployeeModal
          user={editSelectedHistory}
          onClose={() => setEditSelectedHistory(null)}
          onApply={onClickApplyModal}
          isInfo={isInfoModal}
        />
      )}
     */}
      {/* {isFilterModal && (
        <EmployeeFilterModal
          onClose={() => setIsFilterModal(false)}
          onApply={onFilterChange}
          defaultRole={role}
        />
      )} */}
    </main>
  );
};

export default HistoryPage;
